function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    from{transform: rotate(0deg);}\n    to{transform: rotate(360deg);}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n    position: relative;\n    top: auto;\n    left: auto;\n    opacity: 0.8;\n    border: 5px solid #e0e0e0;\n    border-top-color: #8a8a8a;\n    width: ",
        "px;\n    height: ",
        "px;\n    border-radius: 50%;\n    animation: ",
        " 0.7s linear infinite;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
import styled, { keyframes } from 'styled-components';
var DEFAULT_SIZE = 60;
var spin = keyframes(_templateObject());
export var Container = styled.div(_templateObject1(), function(props) {
    return props.size ? props.size : DEFAULT_SIZE;
}, function(props) {
    return props.size ? props.size : DEFAULT_SIZE;
}, spin);
